import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NavController, Platform} from 'ionic-angular';

import { Globals } from '../../providers/globals';
import { ConsumerPointsHandlerProvider } from '../../providers/consumer-points-handler';
import { ConsumerProfilePage } from '../../pages/consumer-profile/consumer-profile';
import { BusinessSiteQrPage } from '../../pages/business-site-qr/business-site-qr';

var $: any;

@Component({
  selector: 'header-block',
  templateUrl: 'header-block.html'
})
export class HeaderBlockComponent {
	@Input('title') title = "BumBum";
	earnedPoints: any = 0;
	showMenu: any = true;

	constructor(
		public navCtrl: NavController,
		private consumerPointsHandlerProvider: ConsumerPointsHandlerProvider, 
		public platform: Platform,
		private globals: Globals
	) {
	}	

	ionViewWillEnter(){
		if($(".menu-toggler").hasClass("foo") == true){
			this.showMenu = false;
		}
	}

	gotoProfile(){
	    this.navCtrl.push(ConsumerProfilePage);
	}	

	hideKeyBoard(){
		console.log("Entered hide keyboard");

		this.platform.ready().then((readySource) => {
			if(readySource=="dom") {
				console.log("Is DOM");
				return
			}		

			console.log("Is native");	
		})
	}

	showUrl(){
		this.navCtrl.push(BusinessSiteQrPage);
	}
}



// WEBPACK FOOTER //
// ./src/components/header-block/header-block.ts